import {ListItem, FormControlLabel, Radio, Stack, Typography} from '@mui/material';
import {formatMasks, formatText} from 'presentation/utils';
import React from 'react';
import {RefundTaggingEnum} from 'main/analytics/gaTagsEnum';
import {DoctorListItemProps} from './types';

export const DoctorListItem = ({
	doctor,
	isLastItem,
	selectedValue,
	onChange,
}: DoctorListItemProps) => {
	const isCNPJ = doctor?.document?.length === 14;

	return (
		<ListItem key={`${doctor?.document}-${doctor?.providerCode}`} divider={!isLastItem}>
			<FormControlLabel
				data-tag-id={RefundTaggingEnum.CLICK_SELECIONAR_PROFISSIONAL}
				value={`${doctor?.document}-${doctor?.providerCode}`}
				control={<Radio />}
				label={
					<Stack>
						<Typography variant="body1">
							{formatText(doctor?.performerName || doctor?.providerName)}
						</Typography>
						{isCNPJ && doctor?.providerName && (
							<Typography variant="body2" color="text.secondary">
								{formatText(doctor?.providerName)}
							</Typography>
						)}
						<Typography variant="body2" color="text.secondary">
							{isCNPJ
								? `CNPJ ${formatMasks('cnpj', doctor?.document)}`
								: `${doctor?.councilNumber}/${doctor?.councilAcronym?.acronym}-${doctor?.councilState?.code} - CPF ${formatMasks('cpf', doctor?.document)}`}
						</Typography>
					</Stack>
				}
				checked={selectedValue === `${doctor?.document}-${doctor?.providerCode}`}
				onChange={event => onChange(event as React.ChangeEvent<HTMLInputElement>)}
			/>
		</ListItem>
	);
};
